import { IOrderLine } from '@cod-monorepo/interfaces';

export interface SelectableOrderLine extends IOrderLine {
    selectionId: string;
}

export function getOrderLineSelectionId(item: IOrderLine): string | undefined {
    const row: IOrderLine & { selectionId?: string } = item;
    return row.selectionId;
}

export function withOrderLineSelectionIds(items: IOrderLine[]): SelectableOrderLine[] {
    return items.map(item => ({
        ...item,
        selectionId: getOrderLineSelectionId(item) ?? crypto.randomUUID()
    }));
}

export function toOrderLineDto(item: IOrderLine): IOrderLine {
    const row: IOrderLine & { selectionId?: string } = item;
    const { selectionId: _selectionId, ...orderLine } = row;
    return orderLine;
}

export function orderLineBusinessKey(item: IOrderLine): string {
    return JSON.stringify(
        Object.entries(item)
            .filter(([key, value]) => !['selectionId', 'id', 'affectedQuantity'].includes(key) && value !== undefined)
            .sort(([left], [right]) => left.localeCompare(right))
    );
}
